'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularjs = require('@uirouter/angularjs');

var _angularjs2 = _interopRequireDefault(_angularjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('blocks.security', ['ng', _angularjs2.default]);


//////////////////
// WEBPACK FOOTER
// ./blocks/security/_security.module.js
// module id = 151
// module chunks = 0